@use "../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../styles/Colors.scss" as Colors;

.advanced-search-modal {
	min-height: 200px;
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-m;

	&__main-filters {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: Constants.$val-spacing-m;

		&--align-right {
			display: flex;
			justify-content: flex-end;

			& > div {
				margin-right: 0;
			}
		}
	}

	&__row {
		display: grid;
		grid-template-columns: 1fr 1fr;
	}

	&__add-button {
		width: 100px;
	}

	&__search {
		width: 50%;
	}

	&__additional-filters {
		&:has(div > :global(.show.dropdown)) {
			// for the love of the game
			& > div > div > div > div {
				position: fixed !important;
			}
		}
	}
}
